document.addEventListener("DOMContentLoaded", () => {
  const offers = [
    { productHandle: "everyday-essentials-set", giftHandle: "damascus-versatile", giftVariant: "47751081394428" },
    { productHandle: "manal-damscus-signature-set", giftHandle: "damascus-master", giftVariant: "47751076905212" }
  ];

  let isSyncing = false;
  let syncQueue = Promise.resolve();
  let lastCartHash = "";

  // ✅ دالة موحدة لتحديث الـ Cart
  const refreshCart = () => {
    if (window.Kalles?.Cart?.updateView) {
      window.Kalles.Cart.updateView();
    } else {
      document.dispatchEvent(new Event("cart:refresh"));
    }
  };

  // ✅ Fetch مع error handling
  const fetchCart = async () => {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error("Cart fetch failed");
      return await res.json();
    } catch (err) {
      console.error("Error fetching cart:", err);
      return null;
    }
  };

  // ✅ تغيير الكمية مع error handling
  const changeGiftQty = async (lineKey, qty) => {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: lineKey, quantity: qty })
      });
      if (!res.ok) throw new Error("Change quantity failed");
      return true;
    } catch (err) {
      console.error("Error changing gift quantity:", err);
      return false;
    }
  };

  // ✅ إضافة هدية مع validation
  const addGift = async (variantId, qty = 1) => {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          properties: { _free_gift: "true" }
        })
      });
      if (!res.ok) {
        const data = await res.json();
        console.warn("Gift add failed:", data.description || "Unknown error");
        return false;
      }
      return true;
    } catch (err) {
      console.error("Error adding gift:", err);
      return false;
    }
  };

  // ✅ حذف هدية
  const removeGift = async (lineKey) => {
    return await changeGiftQty(lineKey, 0);
  };

  // ✅ إنشاء hash للـ cart state (أدق من JSON.stringify)
  const getCartHash = (items) => {
    return items
      .map(i => `${i.id}:${i.quantity}:${i.properties?._free_gift || ''}`)
      .sort()
      .join('|');
  };

  // ✅ دالة الـ sync الرئيسية
  const syncGifts = async () => {
    // منع التنفيذ المتزامن
    syncQueue = syncQueue.then(async () => {
      if (isSyncing) return;
      isSyncing = true;

      try {
        const cart = await fetchCart();
        if (!cart) return;

        // ✅ Check if cart actually changed
        const currentHash = getCartHash(cart.items);
        if (currentHash === lastCartHash) {
          return;
        }

        let changed = false;

        for (const offer of offers) {
          const setItem = cart.items.find(i => i.handle === offer.productHandle);
          const giftItem = cart.items.find(i => 
            i.handle === offer.giftHandle && 
            i.properties?._free_gift === "true"
          );

          // 1️⃣ Set موجود ومفيش هدية → أضفها
          if (setItem && !giftItem) {
            const success = await addGift(offer.giftVariant, setItem.quantity);
            if (success) changed = true;
          }
          // 2️⃣ Set مش موجود وفيه هدية → احذفها
          else if (!setItem && giftItem) {
            const success = await removeGift(giftItem.key);
            if (success) changed = true;
          }
          // 3️⃣ الاتنين موجودين → sync الكمية
          else if (setItem && giftItem && giftItem.quantity !== setItem.quantity) {
            const success = await changeGiftQty(giftItem.key, setItem.quantity);
            if (success) changed = true;
          }
        }

        // ✅ Refresh only if changes were made
        if (changed) {
          refreshCart();
          // Re-fetch to update hash after changes
          const updatedCart = await fetchCart();
          if (updatedCart) {
            lastCartHash = getCartHash(updatedCart.items);
          }
        } else {
          lastCartHash = currentHash;
        }

      } catch (err) {
        console.error("Gift sync error:", err);
      } finally {
        isSyncing = false;
      }
    });

    return syncQueue;
  };

  // ✅ Debounced sync للأداء الأفضل
  let syncTimeout;
  const debouncedSync = () => {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncGifts, 600); // ⏱️ زودت الوقت لـ 600ms
  };

  // ✅ Event listeners
  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest(
      'form[action="/cart/add"] [type="submit"], .btn-addtocart, .add_to_cart_button'
    );
    if (btn) debouncedSync();
  });

  // ✅ Listen for manual cart updates
  document.addEventListener("cart:updated", debouncedSync);
  
  // ✅ Listen for quantity changes in cart drawer
  const observer = new MutationObserver(() => {
    if (document.querySelector('.cart-drawer, .mini-cart, [data-cart-drawer]')) {
      debouncedSync();
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });

  // ✅ Initial sync
  syncGifts();
});